import React from "react";
import { otherCalculators_EN } from "../ConstantsEN";
import SharedHelmet from "../Helmet";
const TITLE = "Other Useful Calculators - Comprehensive Calculation Tools";
const DESCRIPTION = "Explore our collection of specialized calculators for various needs including math, finance, health, and everyday calculations. Free and easy-to-use tools.";
const KEYWORDS = "calculators, math tools, online calculators, finance calculator, health calculator, conversion tools, measurement calculators";
const OG_URL = 'https://do-calculate.com/en/other-calculators';
function CalculatorsList() {
  return (
    <div className="container ltr-container">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div>
        <h1 style={{ fontSize: "26px" }}>{TITLE}</h1>
        <hr />
        <div className="alert alert-secondary" role="alert">
          <p>{DESCRIPTION} </p>
        </div>
      </div>
      <hr />
      <table >
        <thead>
          <tr>
            <th >Calculator</th>
            <th >Description</th>
          </tr>
        </thead>
        <tbody>
          {otherCalculators_EN.map((calculator, index) => (
            <tr key={index}>
              <td>
                <a href={calculator.link}>
                  {" "}
                  <h2 style={{ fontSize: "14px" }}>{calculator.name}</h2>{" "}
                </a>
              </td>
              <td>
                <p>{calculator.description}</p>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <br />
    </div>
  );
}
export default CalculatorsList;
